import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaProcedureCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('proceduresPage.modal.validation.descriptionRequired')),
  price: yup
    .number()
    .min(1, translate('proceduresPage.modal.validation.priceMin'))
    .required(translate('proceduresPage.modal.validation.priceRequired')),
  is_recurrent: yup.boolean().optional(),
  return_days: yup
    .number()
    .nullable()
    .when('is_recurrent', {
      is: true,
      then: (schema) =>
        schema
          .typeError('Informe os dias para retorno')
          .min(1, 'Dias para retorno deve ser no mínimo 1')
          .required('Dias para retorno é obrigatório quando recorrente'),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});

export const schemaProcedureEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('proceduresPage.modal.validation.descriptionRequired')),
  price: yup
    .number()
    .min(1, translate('proceduresPage.modal.validation.priceMin'))
    .required(translate('proceduresPage.modal.validation.priceRequired')),
  status: yup
    .boolean()
    .required(translate('proceduresPage.modal.validation.statusRequired')),
  is_recurrent: yup.boolean().optional(),
  return_days: yup
    .number()
    .nullable()
    .when('is_recurrent', {
      is: true,
      then: (schema) =>
        schema
          .typeError('Informe os dias para retorno')
          .min(1, 'Dias para retorno deve ser no mínimo 1')
          .required('Dias para retorno é obrigatório quando recorrente'),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});
